import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient"; // Provjeri je li putanja do tvog klijenta točna
import LoaderBox from "../HomePage/LoaderBox";
import { motion } from "framer-motion";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "../HomePage/HomeFooter";

const Sponsors = () => {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        // Dohvaćamo samo sponzore koji su označeni kao vidljivi, sortirane po poziciji
        const { data, error } = await supabase
          .from("sponsors")
          .select("*")
          .eq("is_visible", true)
          .order("position", { ascending: true });

        if (error) throw error;
        setSponsors(data || []);
      } catch (error) {
        console.error("Greška pri dohvaćanju sponzora:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSponsors();
  }, []);

  if (loading) return <LoaderBox text="Učitavanje sponzora..." />;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <>
      <Navigation />
      <section className="sponsors-page-wrapper">
        <div className="sponsors-header">
          <h3>Službeni Sponzori</h3>
          <p>Zahvaljujemo partnerima koji podržavaju turnir</p>
        </div>

        {sponsors.length === 0 ? (
          <div
            className="no-sponsors-placeholder"
            style={{ textAlign: "center", color: "#aaa", marginTop: "40px" }}
          >
            <p>Trenutno nema istaknutih sponzora.</p>
          </div>
        ) : (
          <motion.div
            className="sponsors-grid"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {sponsors.map((sponsor) => (
              <motion.a
                href={sponsor.web_url || "#"}
                key={sponsor.id} // Koristimo jedinstveni id iz baze umjesto imena
                className="sponsor-card"
                target={sponsor.web_url ? "_blank" : "_self"}
                rel="noopener noreferrer"
                style={{ "--brand-color": sponsor.bg_color || "#FFFFFF" }}
                variants={itemVariants}
              >
                <div className="logo-wrapper">
                  <img src={sponsor.logo_url} alt={sponsor.name} />
                </div>
              </motion.a>
            ))}
          </motion.div>
        )}
      </section>
      <HomeFooter />
    </>
  );
};

export default Sponsors;
